import type { Template } from "@/types";

export const PO_04_H1_V3: Template[] = [
    {
        id: "po-04-h1v3-01",
        name: "PO 01 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 48, y: 276, width: 239, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 295, y: 276, width: 538, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 841, y: 276, width: 240, height: 363, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1089, y: 276, width: 239, height: 363, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-02",
        name: "PO 02 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "2", x: 113, y: 113, width: 461, height: 691, rotation: 0, imageRotation: 0 },
            { id: "1", x: 800, y: 113, width: 461, height: 346, rotation: 0, imageRotation: 0 },
            { id: "3", x: 800, y: 467, width: 227, height: 336, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1035, y: 467, width: 226, height: 336, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-03",
        name: "PO 03 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 39, y: 0, width: 609, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 765, y: 91, width: 520, height: 346, rotation: 0, imageRotation: 0 },
            { id: "3", x: 765, y: 445, width: 256, height: 379, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1029, y: 445, width: 256, height: 379, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-04",
        name: "PO 04 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 46, y: 276, width: 540, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 594, y: 276, width: 240, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 842, y: 276, width: 239, height: 363, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1089, y: 276, width: 239, height: 363, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h1v3-05",
        name: "PO 05 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 108, y: 126, width: 231, height: 352, rotation: 0, imageRotation: 0 },
            { id: "2", x: 347, y: 126, width: 231, height: 352, rotation: 0, imageRotation: 0 },
            { id: "3", x: 108, y: 486, width: 470, height: 303, rotation: 0, imageRotation: 0 },
            { id: "4", x: 777, y: 75, width: 506, height: 765, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-04-h1v3-06",
        name: "PO 06 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 53, y: 312, width: 188, height: 291, rotation: 0, imageRotation: 0 },
            { id: "2", x: 249, y: 312, width: 188, height: 291, rotation: 0, imageRotation: 0 },
            { id: "3", x: 445, y: 312, width: 188, height: 291, rotation: 0, imageRotation: 0 },
            { id: "4", x: 740, y: 264, width: 581, height: 387, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h1v3-07",
        name: "PO 07 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 44, y: 276, width: 237, height: 356, rotation: 0, imageRotation: 0 },
            { id: "2", x: 289, y: 157, width: 356, height: 237, rotation: 0, imageRotation: 0 },
            { id: "3", x: 289, y: 402, width: 237, height: 356, rotation: 0, imageRotation: 0 },
            { id: "4", x: 761, y: 0, width: 612, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },


    {
        id: "po-04-h1v3-08",
        name: "PO 08 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 97, y: 207, width: 171, height: 246, rotation: 0, imageRotation: 0 },
            { id: "2", x: 97, y: 461, width: 171, height: 246, rotation: 0, imageRotation: 0 },
            { id: "3", x: 276, y: 207, width: 346, height: 500, rotation: 0, imageRotation: 0 },
            { id: "4", x: 630, y: 207, width: 648, height: 500, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h1v3-09",
        name: "PO 09 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 48, y: 276, width: 239, height: 363, rotation: 0, imageRotation: 0 },
            { id: "2", x: 295, y: 276, width: 239, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 542, y: 276, width: 239, height: 363, rotation: 0, imageRotation: 0 },
            { id: "4", x: 789, y: 276, width: 539, height: 363, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h1v3-10",
        name: "PO 10 - H1V3",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h1_v3_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 68, y: 69, width: 1060, height: 778, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1136, y: 69, width: 171, height: 254, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1136, y: 331, width: 171, height: 254, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1136, y: 593, width: 171, height: 254, rotation: 0, imageRotation: 0 }
        ],
    },
];

